export default {
	'bold': 'Bold',
	'italic': 'Italic',
	'underline': 'Underline',
	'strike': 'Strike',
	'unordered': 'Unordered List',
	'ordered': 'Ordered List',
	'outdent': 'Outdent',
	'indent': 'Indent',
	'h1': 'Heading 1',
	'h2': 'Heading 2',
	'h3': 'Heading 3',
	'h4': 'Heading 4',
	'h5': 'Heading 5',
	'h6': 'Heading 6',
	'quote': 'Quote',
	'hardBreak': 'Hard Break',
	'hr': 'Horizontal Rule',
	'left': 'Align Left',
	'center': 'Align Center',
	'right': 'Align Right',
	'justify': 'Justify',
	'link': 'Link',
	'unlink': 'Unlink',
	'superscript': 'Superscript',
	'subscript': 'Subscript',
	'removeFormat': 'Remove Format',
	'undo': 'Undo',
	'redo': 'Redo',
	'viewsource': 'View Source',
	'infoBlock': 'Information',
};